import { render } from "./ElectiveBrochureView.vue?vue&type=template&id=8fe72f7a"
import script from "./ElectiveBrochureView.vue?vue&type=script&lang=js"
export * from "./ElectiveBrochureView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__